export const convertCoinObject = (setState, data) => {
  if (!data) return;
  const md = data.market_data ?? {};
  const price = md.current_price ?? {};
  const mcap = md.market_cap ?? {};
  const vol = md.total_volume ?? {};

  setState({
    id: data.id,
    name: data.name ?? "",
    symbol: data.symbol ?? "",
    image: data.image?.large ?? data.image?.small ?? "",
    desc: data.description?.en ?? "",
    current_price:
      typeof price.usd === "number" ? price.usd : Number(price.usd) || 0,
    market_cap: typeof mcap.usd === "number" ? mcap.usd : Number(mcap.usd) || 0,
    total_volume: typeof vol.usd === "number" ? vol.usd : Number(vol.usd) || 0,
    price_change_percentage_24h:
      md.price_change_percentage_24h != null
        ? Number(md.price_change_percentage_24h)
        : 0,
  });
};
